import React from 'react';
import { useClassName } from 'common/hooks';
import './faqs.less';
import { getContentfulField } from 'common/components';
import { QuestionsAndAnswers } from './QuestionsAndAnswers/QuestionsAndAnswers';
import { MapsAndLocation } from './MapsAndLocation/MapsAndLocation';

export const FAQs = ({ venue }) => {
  const className = useClassName('faqs');
  const mainColor = getContentfulField(venue.parkScreen?.mainColor);
  const secondaryColor = getContentfulField(venue.parkScreen?.secondaryColor);
  const tertiaryColor = getContentfulField(venue.parkScreen?.tertiaryColor);

  return (
    <div
      id="faqs"
      className={className('container')}
      style={{ backgroundColor: tertiaryColor }}>
      <div
        className={className('container__wrapper')}
        style={{
          background: `linear-gradient(180deg, ${secondaryColor} 0%, ${mainColor} 100%)`,
        }}>
        <QuestionsAndAnswers venue={venue} />
        <MapsAndLocation venue={venue} />
      </div>
    </div>
  );
};
